import Drop from '../campaigns/drop';

document.addEventListener('DOMContentLoaded', () => {
  Drop().init();
});
